/**
 * Invoice Payment Page
 * Wrapper page for the InvoicePayment component
 */

import { useParams, useNavigate } from 'react-router-dom';
import { InvoicePayment } from '../components/invoice/InvoicePayment';
import { ErrorBoundary } from '@/components/ErrorBoundary';

export const InvoicePaymentPage = () => {
  const { invoiceId } = useParams<{ invoiceId: string }>();
  const navigate = useNavigate();

  if (!invoiceId) {
    return (
      <div className="card text-center py-12">
        <h2 className="text-2xl font-bold text-neutral-900 mb-2">Invalid Invoice</h2>
        <p className="text-neutral-600 mb-6">Invoice ID is required to process payment</p>
        <button onClick={() => navigate('/')} className="btn-primary">
          Go Home
        </button>
      </div>
    );
  }

  return (
    <ErrorBoundary resetKeys={[invoiceId]}>
      <div className="container mx-auto px-4 py-8">
        <InvoicePayment invoiceId={invoiceId} />
      </div>
    </ErrorBoundary>
  );
};
